import React from 'react';
import PropTypes from 'prop-types';
import './Pagination.css';

export const Pagination = (props) => {
  const { currentPage = 0, itemsPerPage = 0, numberOfItems = 0, onClick = () => {} } = props;
  if (currentPage === 0 || itemsPerPage === 0 || numberOfItems === 0) {
    return null;
  }
  const numberOfPages = Math.ceil(numberOfItems / itemsPerPage);
  // creating an array of numbers from 1...N
  const pageNumbers = Array.from(Array(numberOfPages).keys(), (n) => n + 1);

  const maxDisplay = 5;
  let pageNumberSubset = [];
  if (currentPage <= maxDisplay) {
    pageNumberSubset = pageNumbers.slice(0, maxDisplay);
  } else if (currentPage > numberOfPages - maxDisplay) {
    pageNumberSubset = pageNumbers.slice(-5);
  } else {
    pageNumberSubset = pageNumbers.slice(currentPage - 3, currentPage + 2);
  }

  return (
    <div className="pagination-wrapper">
      <button
        className="pagination__button"
        disabled={currentPage === Math.min(...pageNumbers)}
        onClick={() => onClick(currentPage - 1)}
      >
        <i
          className={
            currentPage === Math.min(...pageNumbers) ? 'pagination__arrow-left--disabled' : 'pagination__arrow-left'
          }
        />
      </button>

      {pageNumberSubset.map((number) => {
        const isCurrentPage = number === currentPage ? 'pagination pagination--selected' : 'pagination';
        const isCurrentPageText =
          number === currentPage ? 'pagination__text pagination__text--selected' : 'pagination__text';

        return (
          <button key={number} className={isCurrentPage} onClick={() => onClick(number)}>
            <span className={isCurrentPageText}>{number}</span>
          </button>
        );
      })}

      <button
        className="pagination__button"
        disabled={currentPage === Math.max(...pageNumbers)}
        onClick={() => onClick(currentPage + 1)}
      >
        <i
          className={
            currentPage === Math.max(...pageNumbers) ? 'pagination__arrow-right--disabled' : 'pagination__arrow-right'
          }
        />
      </button>
    </div>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  numberOfItems: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};
